/* eslint-disable */
export const MODULE_NAMES = {
  HOME_DASHBOARD: 'home:dashboard',
  HOME_DASHBOARD_ACCOUNT_BASED_REPORT: 'home:dashboard:account-based-report',
  HOME_DASHBOARD_ARCHITECT_REPORT: 'home:dashboard:architect-report',
  HOME_DASHBOARD_PM_REPORT: 'home:dashboard:pm-report',
  HOME_DASHBOARD_ACCOUNT_BASED_FILTER: 'home:dashboard:account-based-filter',
  HOME_DASHBOARD_ARCHITECT_FILTER: 'home:dashboard:architect-filter',
  HOME_DASHBOARD_PM_FILTER: 'home:dashboard:pm-filter',
  HOME_DASHBOARD_ARCHITECT_TECHNOLOGY: 'home:dashboard:architect-technology',
  HOME_DASHBOARD_ARCHITECT_EFFORT_DEVIATION: 'home:dashboard:architect-effort-deviation',
  HOME_DASHBOARD_ARCHITECT_UTILIZATION: 'home:dashboard:architect-utilization',
  HOME_DASHBOARD_ARCHITECT_RU_UNIT: 'home:dashboard:architect-ru-unit',
  HOME_DASHBOARD_PM_CSAT: 'home:dashboard:pm-csat',
  HOME_DASHBOARD_PM_QUALITY_AUDIT: 'home:dashboard:pm-quality-audit',
  HOME_DASHBOARD_PM_PMO_AUDIT: 'home:dashboard:pm-pmo-audit',
  HOME_DASHBOARD_PM_RU_UNIT: 'home:dashboard:pm-ru-unit',
  USER_ROLE: 'user-roles-service', // place service name as value of casbin's key
  MASTER_DELIVERY_ROLE: 'masters:delivery:role',
  EMPLOYEE_MANAGEMENT_HISTORY: 'resource:employee-management',
  MASTER_TRAINING_SKILL: 'masters:training:skill',
  MASTER_TRAINING_CERTIFICATION: 'masters:training:certification',
  CERTIFICATION_TARGET: 'certifications:target',
  CONFIGURATION_USER: 'users:user-management',
  CONFIGURATION_SKILL: 'skills:skill-mapping',
  CERTIFICATION_OVERVIEW: 'certifications:overview',
  CERTIFICATION_MAP: 'certifications:map',
  PERMISSION: 'permissions',
  GENERAL_CONFIG_SEARCH: 'general-config:search',
  EMPLOYEE_ONBOARDING: 'employee-profile:onboarding',
  EMPLOYEE_TRAINING: 'employee-profile:trainings-and-assessments',
  EMPLOYEE_PROJECTS: 'employee-profile:projects',
  EMPLOYEE_PERFORMANCE: 'employee-profile:performance',
  EMPLOYEE_ACHIEVEMENTS: 'employee-profile:achievements',
  CONFIGURATION_MANAGE_KPI: 'configuration:manage-kpi',
  MASTER_PERFORMANCE_PERIOD: 'masters:performance:declare-performance-period',
  MASTER_REMARKS: 'masters:performance:declare-remarks',
  DEAL_TRANSITION_WORKFLOW: 'deal-transition:custom-workflow',
  DEAL_TRANSITION_DASHBOARD: 'deal-transition:dashboard',
  DEAL_TRANSITION_REVENUE: 'deal-transition:revenue',
  DEAL_TRANSITION_SLO: 'deal-transition:slo',
  DEAL_TRANSITION_STAFFING: 'deal-transition:staffing-projections',
  MASTER_DEAL_STATUS: 'masters:deal-transition:deal-status',
  MASTER_DEAL_ROLE: 'masters:deal-transition:deal-role',
  MASTER_DEAL_EFFORTS: 'masters:deal-transition:efforts',
  MASTER_TRAINING_CERT_CATEGORY: 'masters:training:certification-category',
  MASTER_COST_MASTER: 'masters:deal-transition:cost-master',
  CONFIGURATION_LEAVE_UPLOAD: 'configuration:data-upload:leave-upload',
  CONFIGURATION_EFFORT_UPLOAD: 'configuration:data-upload:effort-upload',
  CONFIGURATION_FILE_UPLOAD: 'configuration:data-upload:file-upload',
  CONFIGURATION_UPLOAD_CONFIG: 'configuration:upload-config',
  CONFIGURATION_DATE_CONFIG: 'configuration:date-configuration',
  CONFIGURATION_CLOUD_PROVIDER: 'masters:configuration:cloud-provider',
  CONFIGURATION_BILLING_TYPE: 'masters:configuration:billing-type',
  MASTER_DEAL_PARAMETERS: 'masters:deal-transition:parameters',
  MASTER_STAFFAUG_REQUIREMENT_STATUS:
    'masters:staff-aug-status:requirement-status',
  MASTER_STAFFAUG_CLIENT_INTERVIEW:
    'masters:staff-aug-status:client-interview-status',
  MASTER_STAFFAUG_GEOGRAPHY:
    'masters:staff-aug-status:geography',
  MASTER_STAFFAUG_LOST_DROPPED_STATUS:
    'masters:staff-aug-status:lost-dropped-status',
  MASTER_ALLOCATION_STAKE_HOLDERS: 'masters:configuration:allocation-stakeholders',
  MIS_COLLECTION_REPORT: 'mis:collection-report',
  MIS_RESELLER_REPORT: 'mis:reseller-report',
  MIS_DELIVERY_UTILIZATION_REPORT: 'mis:delivery-utilization',
  MIS_HEALTH_CHECK: 'mis:health-check:pmo',
  MIS_STAFF_AUG_REPORT: 'mis:staff-augmentation-report',
  STAFF_AUG_REQ_STATUS: 'staff-augmentation:requirement-status',
  DEAL_TRANSITION_COMMERCIAL_PROJECTIONS:
    'deal-transition:commercial-projections',
  DEAL_TRANSITION_DETAIL_COMMERCIALS: 'deal-transition:deal-detail-commercials',
  DEAL_TRANSITION_EFFORT_ESTIMATION: 'deal-transition:deal-effort-estimation',
  DEAL_TRANSITION_SLA_OVERRIDE: 'deal-transition:deal-sla-override',
  DEAL_TRANSITION_DEAL_ASSIGN: 'deal-transition:deal-assign',
  DEAL_TRANSITION_DEAL_STATUS_CHANGE: 'deal-transition:deal-status-change',
  STAFF_AUG_PROJECT_RESOURCING: 'staff-augmentation:project-resourcing',
  DELIVERY_PROJECT_OVERVIEW: 'delivery:project-overview:project-details',
  DELIVERY_ADD_PROJECTS: 'delivery:add-projects',
  DELIVERY_ADD_STAFFING_REQUEST: 'delivery:staffing-request',
  DELIVERY_ADD_STAFFING_REQUEST_APPROVAL: 'delivery:staffing-request-approval',
  DELIVERY_ALLOCATION_DETAILS_VIEW:
    'delivery:project-overview:allocation-details-view',
  DELIVERY_PROJECT_OVERVIEW_RISK: 'delivery:project-overview:risk',
  DELIVERY_PROJECT_OVERVIEW_ISSUE: 'delivery:project-overview:issue',
  DELIVERY_PROJECT_OVERVIEW_INFOSEC_RISK:
    'delivery:project-overview:infosec-risk',
  TECH_SESSION: 'organization-contribution:tech-session',
  TECH_SESSION_CALENDAR:
    'organization-contribution:tech-session:tech-session-calendar',
  TECH_SESSION_NEW_REQUEST:
    'organization-contribution:tech-session:tech-session-user',
  TECH_SESSION_RECEIVED_REQUEST:
    'organization-contribution:tech-session:tech-session-receive-request',
  ORGANIZATION_BLOGS: 'organization-contribution:blogs',
  MIS_HEALTH_CHECK_PMO: 'mis:health-check:pmo',
  DELIVERY_PROJECT_OVERVIEW_lAST_MONTH:
    'delivery:project-overview:project-logged-effort-percentage-view',
  DELIVERY_PROJECT_OVERVIEW_EFFORT_ESTIMATION:
    'delivery:project-overview:effort-estimation',
  DEAL_TRANSITION_DEAL_EFFORT_APPROVAL:
    'deal-transition:deal-approval:deal-effort-approval',
  DEAL_TRANSITION_DEAL_FINANCIAL_APPROVAL:
    'deal-transition:deal-approval:deal-financial-approval',
  DELIVERY_PROJECT_OVERVIEW_CSAT: 'delivery:project-overview:csat',
  DELIVERY_PROJECT_OVERVIEW_AGM: 'delivery:project-overview:agm',
  DELIVERY_PROJECT_OVERVIEW_EGM: 'delivery:project-overview:egm',
  DELIVERY_PROJECT_OVERVIEW_SGM: 'delivery:project-overview:sgm',
  DELIVERY_PROJECT_STATUS: 'delivery:project-overview:project-status',
  DELIVERY_PROJECT_MANAGER_DETAILS_EDIT:
    'delivery:project-manager-access',
  DELIVERY_STATUS_HISTORY_APPROVAL: 'delivery:project-overview:status-history-approval',
  DELIVERY_AUDIT_SCORE: 'delivery:project-overview:audit-score',
  DELIVERY_RAG_STATUS: 'delivery:project-overview:rag-status',
  DELIVERY_PROJECT_PROGRESS: 'delivery:project-overview:project-progress',
  DELIVERY_PROJECT_DETAILS_UTILIZATION: 'delivery:project-details:utilization',
  FINANCE_MILESTONE: 'finance:milestone',
  FINANCE_MILESTONE_INVOICE_AMOUNT_VIEW:
    'finance:milestone:milestone-invoice-amount-view',
  FINANCE_MILESTONE_AMOUNT_VIEW: 'finance:milestone:milestone-amount-view',
  FINANCE_MILESTONE_RECEIVED_DATE_VIEW:
    'finance:milestone:milestone-received-date-view',
  FINANCE_MILESTONE_REMARKS_VIEW: 'finance:milestone:milestone-remarks-view',
  FINANCE_MILESTONE_PO_NUMBER_VIEW: 'finance:milestone:po-number-view',
  FINANCE_MILESTONE_PO_LINK_VIEW: 'finance:milestone:po-link-view',
  FINANCE_MILESTONE_REPLANNED_DUE_DATE_VIEW:
    'finance:milestone:replanned-due-date-view',
  FINANCE_MILESTONE_COLLECTION_AMOUNT_VIEW:
    'finance:milestone:collection-amount-view',
  FINANCE_MILESTONE_COLLECTION_DATE_VIEW:
    'finance:milestone:collection-date-view',
  FINANCE_EMPLOYEE_COST: 'finance:employee-cost-details',
  PROJECT_CHANGE_REQUEST: 'project:change-request',
  PROJECT_TIME_SHEET_REPORT_LIST_VIEW: 'project:time-sheet-report-list-view',
  PROJECT_TIME_SHEET_REPORT_CALENDAR_VIEW: 'project:time-sheet-report-calendar-view',
  PROJECT_FILE_UPLOAD_REDMINE: 'project:file-upload:redmine-data',
  PROJECT_FILE_UPLOAD_LEAVE: 'project:file-upload:leave-data',
  PROJECT_FILE_UPLOAD_HOLIDAY: 'project:file-upload:holiday-data',
  PROJECT_FILE_UPLOAD_LEAVE_TEST: 'project:file-upload:leave-test',
  PROJECT_FILE_UPLOAD_SALARY: 'project:file-upload:salary-data',
  PROJECT_FILE_UPLOAD_PROJECT_EXPENSE: 'project:file-upload:project-expense',
  PROJECT_FILE_UPLOAD_JIRA: 'project:file-upload:jira-effort-data',
  PROJECT_TIMELINE_CHANGE_REQUEST:
    'delivery:project-overview:timeline-change-request',
  PROJECT_BUDGET_CHANGE_REQUEST_APPROVE: 'project:budget-change-request:approve',
  PROJECT_BUDGET_CHANGE_REQUEST_EFFORTS: 'project:budget-change-request:efforts',
  PROJECT_BUDGET_CHANGE_REQUEST_COST: 'project:budget-change-request:cost',
  DELIVERY_PROJECT_DETAILS_EDIT: 'delivery:project-user-access',
  NOTIFICATIONS: 'notifications',
  MIS_HEALTH_CHECK_ARCHITECTURE: 'mis:health-check:architecture',
  STAFF_AUG_CLONE_REQUIREMENT: 'staff-augmentation:clone-requirement',
  STAFF_AUG_RESUME_GENERATION_VIEW_RESUME: 'staff-augmentation:resume-generation:view-resume-details',
  STAFF_AUG_RESUME_GENERATION_GENERATE_RESUME: 'staff-augmentation:resume-generation:generate-resume',
  STAFF_AUG_RESUME_GENERATION_UPLOAD_RESUME: 'staff-augmentation:resume-generation:upload-resume',
  STAFF_AUG_RESUME_GENERATION_VIEW_RESUME_CONVERT_TO_NIVEUS: 'staff-augmentation:resume-generation:view-resume:convert-to-niveus-format',
  STAFF_AUG_RESUME_GENERATION_VIEW_RESUME_EDIT_RESUME: 'staff-augmentation:resume-generation:view-resume:edit-resume',
  STAFF_AUG_RESUME_GENERATION_VIEW_RESUME_DOWNLOAD_RESUME: 'staff-augmentation:resume-generation:view-resume:download-resume',
  MIS_IMD_VIEW: 'mis:ird',
  MIS_REVENUE_RECOGNITION: 'mis:revenue-recognition',
  MIS_REVENUE_MIS: 'mis:revenue-mis',
  MIS_MILESTONE: 'mis:milestone-mis',
  MASTERS_REGION_LIST: 'masters:configuration:region-list',
  MASTERS_INVOICE_TYPE: 'masters:configuration:invoice-type',
  MASTERS_DELIVERY_METHODOLGY: 'masters:configuration:delivery-methodology',
  MIS_PROJECT_UTILIZATION: 'mis:project-utilization',
  MIS_EMPLOYEE_UTILIZATION_REPORT: 'mis:employee-utilization-report',
  MIS_ACTIVITY_REPORT: 'mis:activity-report',
  MIS_EMPLOYEE_DETAILS: 'mis:employee-mis',
  MIS_EDR_EMPLOYEE_EFFORT: 'mis:edr-employee-effort',
  MIS_EDR_ACTIVITY_REPORT: 'mis:edr-activity-report',
  MIS_ALLOCATION_MIS: 'mis:allocation-mis',
  PO_MIS: 'mis:po-mis',
  DELIVERY_RESOURCE_ALLOCATION_COUNT: 'delivery:project-overview:resource-allocation-count',
  DELIVERY_RESOURCE_ALLOCATION_DETAILS: 'delivery:project-overview:resource-allocation-details',
  RESOURCE_RESOURCE_ALLOCATION: 'resource:resource-allocation',
  MIS_EDR_PROJECT_EFFORT: 'mis:edr-project-effort',
  DELIVERY_PROJECT_UNIT: 'delivery:project-overview:project-unit',
  DELIVERY_PROJECT_UNIT_AMOUNT: 'delivery:project-overview:project-unit-amount',
  DELIVERY_PROJECT_DETAILS_CUSTOMER_TYPE: 'delivery:project-details:customer-type',
  DELIVERY_PROJECT_DETAILS_VG_NVG: 'delivery:project-details:vg/-nvg',
  DELIVERY_PROJECT_DETAILS_EFFORT_LOGGING: 'delivery:project-details:effort-logging',
  DELIVERY_PROJECT_DETAILS_JIRA_PROJECT_ID: 'delivery:project-details:jira-project-id',
  DELIVERY_PROJECT_DETAILS_PROJECT_DL: 'delivery:project-dl',
  DELIVERY_RESOURCE_LOADING_PLAN: 'delivery:resource-loading-plan',
  DELIVERY_RESOURCE_LOADING_APPROVAL_HISTORY: 'delivery:resource-loading-approval-history',
  MIS_FINANCE_REPORT: 'mis:project-employee-cost',
  MIS_TIME_SHEET_LIST_VIEW: 'mis:time-sheet-mis-list-view',
  MIS_TIME_SHEET_CALENDAR_VIEW_EMPLOYEE_WISE: 'mis:time-sheet-mis-calendar-view-employee-wise',
  MIS_TIME_SHEET_CALENDAR_VIEW_ACTIVITY_WISE: 'mis:time-sheet-mis-calendar-view-activity-wise',
  RESOURCE_RESOURCE_MANAGEMENT: 'resource:resource-management',
  RESOURCE_TBH_EMPLOYEE_MANAGEMENT: 'resource:tbh-employee-management',
  RESOURCE_SHIFT_ALLOWANCE: 'resource:shift-allowance',
  RESOURCE_SHIFT_ALLOWANCE_APPROVAL_HISTORY: 'resource:shift-allowance-approval-history',
  MIS_CSAT_HISTORY: 'mis:csat-history',
  RESOURCE_PROJECT_RIGHTS: 'resource:project-rights',
  TBH_RESOURCE_MANAGEMENT: 'resource:tbh-resource-management',
  MANAGE_EMPLOYEE_HISTORY: 'resource:manage-employee-history',
  MIS_RISK_REGISTER: 'mis:risk-register',
  MIS_CSAT_CUSTOMER_DETAILS: 'mis:csat-customer-details',
  MIS_AI_TOOL_MIS: 'mis:ai-tool-mis',
  DELIVERY_PROJECT_INFO_LOOKUP: 'delivery:project-info-lookup',
  MIS_CHANGE_REQUEST: 'mis:change-request',
  MIS_OFFERING_WISE_REPORT: 'mis:offering-wise-report',
  MIS_PROJECT_COST_REPORT: 'mis:project-cost-report',
  MIS_STAFFING_MIS: 'mis:staffing-mis',
  MIS_ROLE_RATIO_REPORT: 'mis:role-ratio-report',
  MIS_GROSS_MARGIN_REPORT: 'mis:gross-margin-report',
  MIS_SALARY_REPORT: 'mis:salary-report',
  MIS_ACCRUED_REVENUE_REPORT: 'mis:accrued-revenue-report',
  MIS_ESTIMATED_VS_ACTUAL_REPORT: 'mis:estimation-vs-actual-report',
  MIS_PROJECT_ALLOCATION: 'mis:project-allocation',
  FINANCE_PO_DETAILS: 'finance:po-details',
  FINANCE_CLIENT_DETAILS: 'finance:client-details',
  FINANCE_ZOHO_CUSTOMER_DETAILS: 'finance:zoho-customer-details',
  FINANCE_ZOHO_INVOICE_DETAILS: 'finance:zoho-invoice-details',
  PEOPLE_VS_PROJECT_COUNT: 'mis:people-vs-project-count',
  PROJECT_CHANGE_REQUEST_APPROVE_REJECT_REQUEST: 'project:change-request:approve-reject-request',
  PROJECT_WISE_SALARY_REPORT: 'mis:projectwise-salary-report',
  PROJECT_WISE_EXPENSE_REPORT: 'mis:project-wise-expense-report',
  MIS_SHIFT_ALLOWANCE: 'mis:shift-allowance',
  MIS_BILLING_REPORT: 'mis:billing-report',
  MIS_BILLING_REPORT_APPROVAL_HISTORY: 'mis:billing-report-approval-history',
  MIS_BILLING_REPORT_AMOUNT_ADDITION: 'mis:billing-report-amount-addition',
  MILESTONE_REPORT: 'mis:milestone-report',
  CONFIGURATION_DEPARTMENT_LIST: 'masters:configuration:department-list',
  CONFIGURATION_EMPLOYEE_EXPERIENCE: 'masters:configuration:employee-experience',
  MASTERS_COUNTRY_LIST: 'masters:configuration:country-list',
  CONFIGURATION_EMPLOYEE_VERTICAL: 'masters:configuration:employee-vertical',
  CONFIGURATION_INVOICE_PAYMENT_STATUS: 'masters:configuration:invoice-payment-status',
  CONFIGURATION_INVOICE_STATUS: 'masters:configuration:invoice-status',
  RESOURCE_AI_ACCESS_REQUEST: 'resource:ai-access-request',
  RESOURCE_AI_ACCESS_REQUEST_APPROVAL: 'resource:ai-access-request-approval',
  CONFIGURATION_ISSUE_CATEGORY: 'masters:configuration:issue-category',
  CONFIGURATION_ISSUE_STATUS: 'masters:configuration:issue-status',
  RESOURCE_AI_ACCESS_REQ_DASHBOARD: 'resource:ai-access-request-dashboard',
  RESOURCE_AI_ACCESS_REQ_DASHBOARD_SUMMARY: 'resource:ai-access-request-dashboard-summary',
};
